import React from 'react';
const IconNavDashboardFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 15V22H7.29999L9.84 15H2ZM14.58 2H2V13H10.57L14.58 2ZM9.42001 22H22V11H13.43L9.42001 22ZM16.7 2L14.16 9H22V2H16.7Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavDashboardFill;